import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { txt } from 'libs/i18n';
import { useSignals } from '@preact/signals-react/runtime';
import { computed } from '@preact/signals-react';
import styles from './style.module.less';
import { usePlaybackContext } from '../../contexts/playback';
import { useEditorContext } from '../../contexts/projectSignal';
const ProjectNameInput = ({ onProjectNameChange, }) => {
    const { playback } = usePlaybackContext();
    const { projectSignal } = useEditorContext();
    useSignals();
    const projectName = computed(() => projectSignal.value.description.name).value;
    const projectReadOnly = computed(() => projectSignal.value.isReadOnly).value;
    const [projectNameInputValue, setProjectNameInputValue] = useState(projectName);
    useEffect(() => {
        // NOTE: this handles situation when someone else changes project name unexpectedly.
        setProjectNameInputValue(projectName);
    }, [projectName]);
    const handleInputChange = (event) => {
        setProjectNameInputValue(event.currentTarget.value);
    };
    const handleProjectNameChangeBlurred = async (event) => {
        const { value } = event.currentTarget;
        const newName = value.trim() === '' ? txt('untitled') : value;
        if (newName === projectName) {
            return;
        }
        await onProjectNameChange(newName);
    };
    const handleProjectNameChangeFocused = () => {
        if (playback.playing) {
            playback.pause();
        }
    };
    return (_jsx(Input, { className: styles.projectNameInput, type: "text", disabled: projectReadOnly, value: projectNameInputValue, onChange: handleInputChange, spellCheck: false, onBlur: handleProjectNameChangeBlurred, onFocus: handleProjectNameChangeFocused, id: "projectName" }));
};
export default ProjectNameInput;
